import React, { useState, useEffect } from "react";
import {
  CardHeader,
  Card,
  CardBody,
  CardTitle,
  Badge,
  Button,
  Spinner,
} from "reactstrap";
import "assets/scss/custom.scss";
import { FaTrashAlt } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import SelectAddonsModal from "./SelectAddonsModal";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import ItemCounter from "./ItemCounter";
import AddOnCounter from "./AddOnCounter";
import pizzalabel from "assets/img/pizzalabel.svg";
import { getItemAddOns } from "store/actions/addOnsAction";
import { useDispatch } from "react-redux";
import { updateItemInstructions } from "store/actions/cartAction";

const ItemCard = ({ item, handleRemoveItem, hasAnyItemAddon }) => {
  const dispatch = useDispatch();
  const [localAddons, setLocalAddons] = useState([]);
  const [addonModalOpen, setAddonModalOpen] = useState(false);
  const [isFetchingAddons, setIsFetchingAddons] = useState(false);
  const [instructions, setInstructions] = useState(item.instructions || "");

  useEffect(() => {
    const fetchAddons = async () => {
      setIsFetchingAddons(true);
      const addons = await getItemAddOns(item?.id);
      setLocalAddons(addons);
      setIsFetchingAddons(false);
    };

    if (item?.id) {
      fetchAddons();
    }
  }, [item?.id]);
  const toggler = () => {
    setAddonModalOpen((prev) => !prev);
  };
  const capitalizeWords = (str) =>
    str?.replace(/\b\w/g, (char) => char.toUpperCase()) || "";

  const addoncontainerstyle = {
    borderRadius: "10px",
    background: "#fff",
    boxShadow: "0 4px 10px rgba(0,0,0,0.09)",
  };

  const addonBoxStyle = {
    maxHeight: "100px",
    overflowY: "auto",
    paddingRight: "6px",
  };
  const renderNoAddonsMsg = () => {
    return (
      <div className="mt-3 mb-3 p-2" style={addoncontainerstyle}>
        <div
          className="d-flex align-items-center justify-content-center fw-bold"
          style={{
            minHeight: "100px",
            overflowY: "auto",
            paddingRight: "6px",
            fontWeight: "500",
          }}
        >
          No addons selected
        </div>
      </div>
    );
  };

  return (
    <>
      <Card
        className="w-100 h-100 border border-gray position-relative bg-secondary"
        style={{ boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)" }}
      >
        <div
          className="d-flex justify-content-center align-items-center position-absolute cursor-pointer bg-white"
          style={{
            width: "25px",
            height: "25px",
            borderRadius: "9999px",
            top: "-10px",
            right: "-10px",
            boxShadow: "0 0 6px rgba(0, 0, 0, 0.5)",
            zIndex: "10",
          }}
          onClick={() => {
            handleRemoveItem(item?.orderItemID);
          }}
        >
          <FaTrashAlt size={13} className="text-danger" />
        </div>
        <CardHeader
          className="relative w-100 p-0 overflow-hidden"
          style={{ height: "150px" }}
        >
          {item?.new && (
            <Badge color="success" className="position-absolute top-2 left-2">
              New
            </Badge>
          )}
          <div className="flex-shrink-0 h-100 text-center">
            {Array.isArray(item?.images) && item.images.length <= 1 ? (
              <img
                alt={item?.name}
                src={item?.images?.[0] || pizzalabel}
                className="w-100 h-100"
                style={{ objectFit: "cover" }}
              />
            ) : (
              <Swiper
                modules={[Autoplay]}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                loop={true}
                spaceBetween={10}
                slidesPerView={1}
                style={{
                  width: "100%",
                  height: "100%",
                  overflow: "hidden",
                }}
              >
                {item?.images?.map((img, idx) => (
                  <SwiperSlide key={idx}>
                    <img
                      alt={`slide-${idx}`}
                      src={img || pizzalabel}
                      className="w-100 h-100"
                      style={{ objectFit: "cover" }}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        </CardHeader>
        <CardBody className="d-flex flex-column justify-content-between custom-cardBody-padding bg-secondary">
          <div>
            <CardTitle className="fs--14 fw--700  mb-0 p-0">
              {item?.name}
            </CardTitle>
          </div>

          {item?.selectedAddons?.length > 0 ? (
            <div className="mt-3 mb-3 p-2" style={addoncontainerstyle}>
              <div style={addonBoxStyle}>
                {item?.selectedAddons?.map((entry, idx) => (
                  <div
                    key={entry.id}
                    className={`py-3 px-2 d-flex flex-column justify-content-between ${
                      idx !== item.selectedAddons.length - 1 ? "mb-3" : ""
                    }`}
                    style={{
                      borderRadius: "8px",
                      background: "#f9f9f9",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                    }}
                  >
                    {/* Addon Row */}
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1 overflow-hidden">
                        <span
                          className="text-truncate"
                          style={{
                            fontSize: "14px",
                            display: "inline-block",
                            maxWidth: "100%",
                          }}
                          title={entry.name}
                        >
                          {capitalizeWords(entry?.name)}
                        </span>
                      </div>

                      <span
                        className="ms-2 text-success fw-bold"
                        style={{ fontSize: "14px", whiteSpace: "nowrap" }}
                      >
                        {item.currency || "$"}
                        {entry.price === 0 ? " Free" : entry.price}
                      </span>
                    </div>

                    <div className="d-flex justify-content-center mt-2">
                      <AddOnCounter
                        orderItemID={item?.orderItemID}
                        addon={entry}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : hasAnyItemAddon ? (
            renderNoAddonsMsg()
          ) : (
            <></>
          )}

          <div className="mt-2">
            <div className="form-group mb-0">
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Add special instructions"
                value={instructions}
                onChange={(e) => {
                  const newInstructions = e.target.value;
                  setInstructions(newInstructions);
                  dispatch(
                    updateItemInstructions(item.orderItemID, newInstructions)
                  );
                }}
              />
            </div>
          </div>

          <div className="fs--14 w-100 d-flex flex-row justify-content-between mt-2">
            <div className="fw--400">{item?.size}</div>
            <div className="fw--400">
              {item?.currency}&nbsp;{item?.price}
            </div>
          </div>
          <div className="fs--14 w-100 d-flex flex-row justify-content-between mt-2">
            <div className="fw--400">Total:</div>
            <span className="custom-price-color fw--14 fw--600">
              {item?.currency || "$"}&nbsp;{item?.totalPrice}
            </span>
          </div>
          <ItemCounter orderItem={item} />
          {isFetchingAddons ? (
            <Button color="secondary" size="sm" className="mt-2" disabled>
              <Spinner size="sm" className="mr-2" /> Fetching addons...
            </Button>
          ) : localAddons.length > 0 ? (
            <Button
              color="primary"
              size="sm"
              className="mt-2"
              onClick={() => setAddonModalOpen(true)}
            >
              Select Addon
            </Button>
          ) : (
            <Button color="danger" size="sm" className="mt-2" disabled>
              No addons available
            </Button>
          )}
        </CardBody>
      </Card>

      {addonModalOpen && (
        <SelectAddonsModal
          addons={localAddons}
          orderItemID={item?.orderItemID}
          isOpen={addonModalOpen}
          toggler={toggler}
        />
      )}
    </>
  );
};

export default ItemCard;
